/** Review is an assessment, not an approval or lock. Unknown states fail closed. */
export const editableBudgetStatuses = ['Draft', 'Reviewed', 'Awaiting review', 'Returned for amendment', 'Rejected'];
export function canEditBudget(budget) {
    return !budget.demand_approved_at && !budget.approved_at && !budget.locked_at && editableBudgetStatuses.some(status => status === budget.status);
}
//# sourceMappingURL=budget-editability.js.map